import './scss/spa.scss';
import Router from '../../utils/router.js';
import Nav from './nav';
import DashboardView from './views/dashboard/view';
import OrdersView from './views/orders/view';
import PersonalDetailsView from './views/personal-details/view';
import SavedItems from './views/saved-items/view';
import DigitalServiceRecord from './views/digital-service-record/view';
import ValueYourCarView from './views/value-your-car/view';
import Garage from './views/garage/view.js';
import ServicePlansView from './views/service-plans/view.js';

export default class MyAccount2SPA {
    constructor(el) {
        this.el = el;
        this.logoutPath = el.dataset.logoutPath;
        this.util = window.HONDA.MyAccount2;
        this.router = window.HONDA.Router;
        this.nav = new Nav(this);
        this.views = {
            dashboard: new DashboardView(this),
            orders: new OrdersView(this),
            personal: new PersonalDetailsView(this),
            savedItems: new SavedItems(this),
            garage: new Garage(this),
            dsr: new DigitalServiceRecord(this),
            valueYourCar: new ValueYourCarView(this),
            servicePlans: new ServicePlansView(this),
        };

        this.init();
        this.bind();
        this.setup();
        this.paymentRoute();
    }

    init() {
        if (!this.util.isLoggedIn()) {
            this.showModal();
        }
        this.util.addEventListener('expires', () => this.showModal());
    }

    showModal() {
        this.util.showModal({ view: 'login', close: true, guest: false });
    }

    bind() {
        this.util.addEventListener('close', () => {
            if (!this.util?.modal?.params?.password) {
                this.redirect(this.logoutPath || '/');
            }
        });

        this.util.addEventListener('logout', () => {
            if (!this.util?.modal?.params?.password) {
                this.util.showModal({ view: 'login' });
            }
        });
    }

    hideViews() {
        Object.values(this.views).forEach((view) => view.hide());
    }

    paymentRoute() {
        if(location.search.includes('paymentStatus=')){
            this.router.update('orders');
        }
    }

    setup() {
        this.router
            .add('dashboard', () => {
                this.hideViews();
                this.views.dashboard.show();
            })
            .add('orders', () => {
                this.hideViews();
                this.views.orders.show();
            })
            .add('saved-items', () => {
                this.hideViews();
                this.views.savedItems.show();
            })
            .add('garage', () => {
                this.hideViews();
                this.views.garage.show();
            })
            .add('garage/digital-service-record', () => {
                this.hideViews();
                this.views.dsr.show();
            })
            .add('garage/value-your-car', () => {
                this.hideViews();
                this.views.valueYourCar.show();
            })
            .add('garage/service-plans', () => {
                this.hideViews();
                this.views.servicePlans.show();
            })
            .add('personal-details', () => {
                this.hideViews();
                this.views.personal.show();
            })
            .else(() => {
                this.router.update('dashboard');
            })
            .match();
    }

    redirect(url) {
        window.location.href = url;
    }

    refreshOrder() {
        this.views.dashboard.populate();
        this.views.orders.populate();
    }

}

document.addEventListener('DOMContentLoaded', () => {
    window.HONDA.Router = window.HONDA.Router || new Router();
    document.querySelectorAll('.my__account__2-spa').forEach((el) => (el.classList.contains('load') ? new MyAccount2SPA(el) : null));
});
